import type { ColDef } from 'ag-grid-community';

import { useProjectTaskGridDragColumns, useSyncColumnStateFromUser } from '../../../state/projectTasks';

export const useColumnsState = (columnDefs: ColDef[]) => {
  useSyncColumnStateFromUser();
  return useProjectTaskGridDragColumns(columnDefs);
};
